import axios from "axios";
import { getToken } from "./tokenGetter";

const axiosWithAuth = async (contentType = "application/json") => {
  try {
    const token = await getToken(); // ✅ Get the latest token from Auth0
    if (!token) throw new Error("No token available for authentication");

    return axios.create({
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": contentType,
      },
    });
  } catch (error) {
    console.error("axiosWithAuth error:", error);
    throw error;
  }
};

export default axiosWithAuth;
